export default {
  addToast({ commit }, { message }) {
    commit('addToast', { message });
  },

  clearToasts({ commit }) {
    commit('clearToast');
  }
};
